__turbopack_context__.v({
  "shimmer": "Animation-module__SpzuAa__shimmer",
  "skeleton": "Animation-module__SpzuAa__skeleton",
});
